import React, { useState, useCallback, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { getCurrentAccDetailsSelector, getMenuListSelector } from '../../store/selectors/app.selector'
import Loading from 'custom/assets/loaders/Loading'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import CardLessService from '../../services/cardLessCash.service'
import AddIcon from 'custom/assets/common-icons/Add.svg'
import { CARD_LESS_CASH_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import { BUTTON_KEYS } from './../../utils/translation-constants';
import Pagination from 'react-js-pagination'
import NeoButton from '../../components/NeoButton/NeoButton' 

export default function CardLessCash() {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(1)
  const [tokenList, setTokenList] = useState([])
  const accountDetails = useSelector(getCurrentAccDetailsSelector) || {}
  const [noRecords, setNoRecords] = useState(false)
  const [expanded, setExpanded] = useState(null)
  const [status, setStatus]=useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 10
  const [totalRecords, setTotalRecords] = useState(10);
  const statusList=[
    "PENDING",
    "ACCEPTED",
    "REVERSED",
    "CANCELLED",
    "EXPIRED",
  ]
  const menuConfig = useSelector(getMenuListSelector)['CARDLESS_CASH'] || {}
  
  useEffect(() => {
    cardLessViewDetails(0)
  }, [])

  const cardLessViewDetails = useCallback(async (page) => {
    try {
      setStage(0)
      let reqParams = {
        status: status || '',
        page:page,
        size:pageLimit,
        srcAccount:accountDetails.accountNo,
      }
      const response = await CardLessService.viewToken(reqParams)
      if (response.status === 200) {
        setTokenList(response.data['tokens']['content'])
        setNoRecords(response.data['tokens']['content'].length === 0 ? true : false)
      }
      setStage(1)
    } catch (err) {
      setLoading(false)
      setStage(1)
    }
  }, [accountDetails, status])

  const handleCancelToken = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        let reqParams = {
          status: selected.status,
          token: selected.token,
          // reqId:selected.token,
          srcAccount:selected.sourceAccountNo,
        }
        const response = await CardLessService.cancelToken(reqParams)
        if (response.status === 200) {
          setLoading(false)
          toast(response.data['message'])
          cardLessViewDetails(0)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [accountDetails],
  )

  const paginationChange = useCallback(
    async (page) => {
      setCurrentPage(page);
      viewScheduledPaymentsList(page - 1);
    },[]);


  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderCardLessViewForm()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderCardLessViewForm() {
    return (
      <>
        {noRecords && <div className='no-data-found'>{t(CARD_LESS_CASH_KEYS.NO_RECORDS)} </div>}

        {tokenList.map((option, index) => (
          <>
            <div key={index} className='approval-card'>
              <div
                className='approval-card-header'
                onClick={async () => {
                  if (expanded == index) {
                    setExpanded(null)
                  } else {
                    setExpanded(index)
                  }
                }}>
                <span>{t(CARD_LESS_CASH_KEYS.TOKEN_NO)}: {option.token}</span>
                <span>
                  <span> {t(CARD_LESS_CASH_KEYS.EXPIRY_DATE)}: {moment(option?.expiry).format('DD-MM-YYYY,h:mm a')}</span>
                  <span style={{ marginTop: 5 }}>
                    {' '}
                    {t(CARD_LESS_CASH_KEYS.STATUS)} : {option.status}
        
                  </span>
                </span>
              </div>
              {expanded === index && (
                <div className='approval-card-body'>
                  <div className='row'>
                    <div className='col-4'>
                      <label>{t(CARD_LESS_CASH_KEYS.TOKEN_NO)}</label>
                      <span>{option?.token || '-'}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARD_LESS_CASH_KEYS.ACCOUNT_NO)}</label>
                      <span>{option?.sourceAccountNo || '-'}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARD_LESS_CASH_KEYS.MOBILE_NO)}</label>
                      <span>{option?.mobileNumber || '-'}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARD_LESS_CASH_KEYS.AMOUNT)}</label>
                      <span>{option?.amount || '-'}</span>
                    </div>

                    <div className='col-4'>
                      <label>{t(CARD_LESS_CASH_KEYS.CREATED_DATE)}</label>
                      <span>{moment(option?.createdDate).format('DD-MM-YYYY,h:mm a')}</span>
                    </div>

                    <div className='col-4'>
                      <label>{t(CARD_LESS_CASH_KEYS.EXPIRY_DATE)}</label>
                      <span>{moment(option?.expiry).format('DD-MM-YYYY,h:mm a')}</span>
                    </div>
                    <div className='col-4'>
                      <label>{t(CARD_LESS_CASH_KEYS.STATUS)}</label>
                      <span>{option.status}
                        {/* {option.status === 'P' && 'Processed'}
                        {option.status === 'A' && 'Active'}
                        {option.status === 'C' && 'Canceled'}
                        {option.status === 'E' && 'Expired'} */}
                      </span>
                    </div>
                  </div>
                  {(option.status === 'PENDING' || option.status === 'EXPIRED') && (
                    <div className='d-flex' style={{ marginTop: 20, justifyContent: 'center' }}>
                      {loading ? (
                        renderLoading()
                      ) : (
                        <a onClick={() => handleCancelToken(option)}>{t(CARD_LESS_CASH_KEYS.CANCEL_TOKEN)}</a>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
        ))}

        <div className='d-flex justify-content-center mb-5 mt-2'>
          {(!loading && tokenList?.length > 0) && (
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={pageLimit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={5}
              itemClass='page-item'
              linkClass='page-link'
              onChange={paginationChange}
            />
          )}
        </div>
      </>
    )
  }

  return (
    <LayoutWithAccountCard keyPath={'CARD_LESS_CASH'} breadCumKey='CARD_LESS_CASH'>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <span className='font-weight-bold'>{t(CARD_LESS_CASH_KEYS.TITLE)}</span>
          </div>
        </div>
        {menuConfig["GENERATE_TOKEN"] && (
        <div className='col-5 text-right'>
          <button
            onClick={() => history.push('/cardLessCash/generateToken')}
            type='button'
            tabIndex={"1"}
            className='btn p-2 detailed-statement-btn'>
            <img width={25} height={25} src={AddIcon} />
            <span style={{ marginLeft: 10 }} className='font-weight-600'>
              {t(CARD_LESS_CASH_KEYS.GENERATE_TOKEN)}
            </span>
          </button>
        </div>
        )}
      </div>
      <div className='row col-12 align-center p-0 m-0 mb-3'>
        <label className='control-label col-2 text-center py-3'> {t(CARD_LESS_CASH_KEYS.SEARCH_BY)}:</label>
        <div className='col-10 p-0 d-flex justify-content-between align-items-center'>
          <label className='control-label col-2'>{t(CARD_LESS_CASH_KEYS.STATUS)} :</label>
          <select tabIndex={"2"} className={`form-control col-6`}
            value={status}
            onChange={(e) => setStatus(e.target.value)}>
            <option value='' disabled >{t(CARD_LESS_CASH_KEYS.SELECT_STATUS)}</option>
            {(
              statusList.map((item, i) => (
                <option key={i} >
                  {item}
                </option>
              ))
            )}
          </select>
          <div className="col-4">
            <NeoButton
              tabIndex='3'
              onClick={() => cardLessViewDetails(0)}
              type='button'
              mode='newDesign'
              text={t(BUTTON_KEYS.SEARCH)}
            />
          </div>
        </div>

      </div>
      <div>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
